import { render, staticRenderFns } from "./wheel2.vue?vue&type=template&id=01941d46&"
import script from "./wheel2.vue?vue&type=script&lang=js&"
export * from "./wheel2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports